module.exports = __webpack_public_path__ + "img/credit-cards.1db75f33.svg";